import React from 'react';
import { observer } from 'mobx-react-lite';
import { roundTimeStore } from '../../store/roundTimeStore';
import { roundInfoStore } from '@pascal/pascal-core/shared/core/store';
import { gameStore } from '../../store/gameStore';
import { useTranslation } from '@pascal/pascal-core';

const Timer = observer(() => {
  const t = useTranslation();
  return (
    <>
      <div
        className={`place-ber-text-label ${
          gameStore.isNotification ? 'no-more-bets' : gameStore.isBetsClosed ? 'wait' : 'place'
        }
          `}
        data-place={t('PLACE_YOUR_BETS')}
        data-bet={t('NO_MORE_BETS')}
        data-wait={t('WAIT_FOR_NEXT_ROUND')}
      />
      <div className='place-bet-load-wrp'>
        {roundTimeStore.time !== null && (
          <div
            className='place-bet-filler'
            style={{
              width: `${((roundTimeStore.time - 1) * 100) / (roundInfoStore.duration - 1)}%`,
            }}
          />
        )}
      </div>
    </>
  );
});

export default Timer;
